export const zIndex = {
  dropdown: 1400,
  /**
   * A floating layer opened from inside another one — a calendar launched from a filter panel or a
   * popover. It has to clear `dropdown`, or it is drawn underneath the surface that opened it.
   */
  nestedDropdown: 1500,
  tooltip: 1600,
} as const;
